export default __webpack_public_path__ + "static/media/white.6bcb53ff.svg";